import { BMPrimitives, useBMTheme } from "@traveloka/district-bloom";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { StyleSheet } from "react-native";
import { FullScreenDialog } from "../../../../components";
import { useTravelerPicker } from "../../../../providers/api/TravelerPickerContext";
import { Traveler } from "../../../../providers/api/types";
import { HotelSearchFormValues } from "../types";
import EmployeeList from "./EmployeeList";
import NonEmployeePicker from "./NonEmployeePicker";
import { BMSnackbarManager } from "../../../../components/BMSnackbar/BMSnackbar";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";

type Props = {
  isVisible: boolean;
  closeDialog: () => void;
};

const BANNER_VISIBILIBITY_DURATION = 10000;

export default function TravelerPicker(props: Props) {
  const { isVisible, closeDialog } = props;
  const [showNonEmployeePicker, setShowNonEmployeePicker] = useState(false);
  const [numOfAdults, setNumOfAdults] = useState(0);
  const [numOfChildren, setNumofChildren] = useState(0);
  const [selectedEmployees, setSelectedEmployees] = useState<Traveler[]>([]);
  const [childrenAges, setChildrenAges] = useState<string[]>([]);
  const { handleSaveTravelerPicker } = useTravelerPicker();
  const { CorporateHotelSearchForm: cr } = useMobileContentResource();

  const bmTheme = useBMTheme();
  const form = useFormContext<HotelSearchFormValues>();

  useEffect(() => {
    if (numOfAdults + numOfChildren + selectedEmployees.length >= 30) {
      triggerMaxTravelerBanner();
    }
  }, [numOfAdults, numOfChildren, selectedEmployees]);

  function triggerMaxTravelerBanner() {
    BMSnackbarManager.show({
      withCloseButton: true,
      type: "RED",
      title: "",
      duration: BANNER_VISIBILIBITY_DURATION,
      message: formatMessage(cr.bannerMaxTraveler, {
        maxTraveler: 30,
      }),
    });
  }

  function handleSaveNonEmployees(
    numOfAdults: number,
    numOfChildren: number,
    childrenAges: string[]
  ) {
    setNumOfAdults(numOfAdults);
    setNumofChildren(numOfChildren);
    setChildrenAges(childrenAges);
  }

  function handleSave() {
    form.setValue("nonEmployeeTravelers.adults", numOfAdults);
    form.setValue("nonEmployeeTravelers.childrenAges", childrenAges);
    form.setValue("travelers", selectedEmployees);
    if (selectedEmployees.length === 1 && !numOfAdults && !numOfChildren) {
      form.setValue("employeeName", selectedEmployees[0].fullname);
    }
    handleSaveTravelerPicker();
    closeDialog();
  }

  return (
    <FullScreenDialog
      style={[
        { backgroundColor: bmTheme.BMComponents.BMStyleSurfaceBgcolor },
        styles.container,
      ]}
      visible={isVisible}
    >
      {!showNonEmployeePicker ? (
        <EmployeeList
          openNonEmployeePicker={() => setShowNonEmployeePicker(true)}
          closeDialog={closeDialog}
          numOfAdults={numOfAdults}
          numOfChildren={numOfChildren}
          selectedEmployees={selectedEmployees}
          setSelectedEmployees={setSelectedEmployees}
          handleSave={handleSave}
        />
      ) : (
        <NonEmployeePicker
          numOfAdults={numOfAdults}
          numOfChildren={numOfChildren}
          childrenAges={childrenAges}
          selectedEmployees={selectedEmployees}
          handleSaveNonEmployees={handleSaveNonEmployees}
          triggerMaxTravelerBanner={triggerMaxTravelerBanner}
          closeNonEmployeePicker={() => setShowNonEmployeePicker(false)}
        />
      )}
    </FullScreenDialog>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: BMPrimitives.BMSize.md,
  },
});
